import { useForm as useInertiaForm } from "@inertiajs/vue3";
import { VisitOptions } from "@inertiajs/core";
import axios from "axios";
import { watch } from "vue";
import { debounce } from "lodash-es";

export function useForm<T extends object>(method: string, url: string, data: T) {
  const form = useInertiaForm<T>(data);

  const validate = debounce((name: keyof T) => {
    axios
      .request({
        method,
        url,
        data: form,
        headers: {
          Precognition: true,
          "Precognition-Validate-Only": name,
        } as any,
      })
      .then((res) => {
        console.log(res)
        form.clearErrors(name);
      })
      .catch((error) => {
        console.log(error)
        form.setError(name, error.response.data.errors[name]);
      });
  }, 500)

  function submit(options: Partial<VisitOptions> = {}) {
    form.submit(method as any, url, {
      ...options,
      preserveScroll: true,
      preserveState: true,
    });
  }

  watch(() => form.data(), (value) => {
    console.log(value)
  })

  return new Proxy(form, {
    get(target, prop, receiver) {
      if (prop === "submit") {
        return submit;
      } else if (prop === "validate") {
        return validate;
      }

      return Reflect.get(target, prop, receiver);
    },
    set(target, p, newValue, receiver) {
      let something = Reflect.set(target, p, newValue, receiver);
      validate(p as any);
      return something;
    },
  }) as typeof form & { submit: typeof submit, validate: typeof validate };
}
